import React from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import DisApprovedStatusDialog from "./DisApprovedStatusDialog";
import { useUpdateRequestStatusMutation } from "src/services/RecordingRequestServices";
import { showToast } from "src/utils/showToaster";

export type DisApprovedStatusDialogValues = {
  reason: string;
};

type Props = {
  onClose: () => void;
  requestId: any;
};

const DisApprovedStatusDialogWrapper = ({ onClose, requestId }: Props) => {
  const [updateStatus] = useUpdateRequestStatusMutation();

  // Form Initial Values
  const initialValues: DisApprovedStatusDialogValues = {
    reason: "",
  };

  // Validation Schema
  const validationSchema = object().shape({
    reason: string().required("Please enter reason"),
  });

  // Handle Submit
  const handleSubmit = (
    values: DisApprovedStatusDialogValues,
    { setSubmitting, resetForm }: FormikHelpers<DisApprovedStatusDialogValues>
  ) => {
    const formattedValues = {
      status: "DISAPPROVED",
      approverRemark: values?.reason,
    };

    updateStatus({ id: requestId?._id, body: formattedValues }).then(
      (res: any) => {
        if (res?.error) {
          showToast("error", res?.error?.data?.message);
        } else {
          if (res?.data?.status) {
            showToast("success", res?.data?.message);
            resetForm();
            onClose();
          } else {
            showToast("error", res?.data?.message);
          }
        }
        setSubmitting(false);
      }
    );
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <DisApprovedStatusDialog
              formikProps={formikProps}
              onClose={onClose}
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default DisApprovedStatusDialogWrapper;
